/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationReturnItemsDialog extends _Ext.ItemEditorDialog<CertificationReturnItemsRow> {
        protected getFormKey() { return CertificationReturnItemsForm.formKey; }
        protected getLocalTextPrefix() { return CertificationReturnItemsRow.localTextPrefix; }
        protected getDeletePermission() { return CertificationReturnItemsRow.deletePermission; }
        protected getInsertPermission() { return CertificationReturnItemsRow.insertPermission; }
        protected getUpdatePermission() { return CertificationReturnItemsRow.updatePermission; }

        public form = new CertificationReturnItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        getItem() {
            return this.getSaveEntity();
        }

        // #region Constructor
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            // #region UI
            //Make grid full width 
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // #endregion

            // #region Field Change Events

            this.form.Pieces.changeSelect2(e => {
                Q.Authorization
                if (this.form.Pieces.value != null) {
                    if (this.entity.ItemTypeId != 101) {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                        if (parseInt(this.form.CalcOnId.value) == 3) {
                            this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                            this.form.GrossAmount.value = this.form.NetAmount.value;
                        }
                    }
                    else {
                        if (!this.form.HasBom.value)
                            Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                        else
                            Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);


                        if (parseInt(this.form.CalcOnId.value) == 3) {
                            this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                        }
                        else {
                            if (this.form.Weight.value > 0)
                                this.form.GrossAmount.value = this.form.Weight.value * this.form.NetAmount.value;
                        }
                    }
                }
            });

           
            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });


            this.form.UnitLabour.changeSelect2(e => {
                if (this.form.UnitLabour.value != null) {
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                    if (this.form.Pieces.value != null) {
                        this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                    }
                }
            });

            var min = 0, max = 0, std = 0;

            this.form.Purity.change(e => {
                if (this.form.Purity.value != null) {
                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    min = purity.MinPurity;
                    max = purity.MaxPurity;
                    std = purity.StdPurity;
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = this.form.Purity.value;
                    }
                    
                }
            });

            // #endregion

            //*** BOM row add Edit Delete Event ****

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }
        // #endregion

        // #region Open Dialog, Close Dialog etc

        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.ItemMaster = (this.parentEditor.parentDialog as CertificationReturnDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDisount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            //this.Setfields();

            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            }
            this.Setfields();
        }

        onDialogClose() {
            this.Closing = true;
        }

        // #endregion

        // #region Common Functions
       

        // **** Method to set fields as per Item Type Called from various Events ****
        private Setfields() {
            // **** Hide Jewellery Fields **** //
            if (this.entity.ItemTypeId != 101) {
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ProductSizeId);

                q.hideField(this.form.UnitLabour);
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces);
                q.hideField(this.form.WstPer);
                q.hideField(this.form.WstWt);
                q.hideField(this.form.Line_No);
                q.hideField(this.form.SKU);
                q.hideField(this.form.CategoryId);
                q.hideField(this.form.HasBom);
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);
                this.form.HasBom.value == false;

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndSetRequiredField(this.form.KaratId);
                    q.showAndSetRequiredField(this.form.MetalColorId);
                    q.showAndSetRequiredField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);
                    this.form.CalcOnId.value = "4";
                    this.form.CalcUnitId.value = "7"

                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.StoneCutId);
                    q.hideField(this.form.StonePolishId);
                    q.hideField(this.form.StoneSymmetryId);
                    q.hideField(this.form.StoneFluorescenceId);
                    q.hideField(this.form.StoneCuletId);
                    q.hideField(this.form.StoneGirdleId);
                    q.hideField(this.form.StoneTable);
                    q.hideField(this.form.StoneDepth);
                    q.hideField(this.form.Pieces);

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 104;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "123";

                    switch (this.form.ProductTypeId.value) {
                        case "5":
                            this.form.SubCategoryId.value = "301";
                            break;
                        case "6":
                            this.form.SubCategoryId.value = "302";
                            break;
                        case "7":
                            this.form.SubCategoryId.value = "303";
                            break;
                    }
                }

                // **** Stone Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ShapeId) : q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.showAndSetRequiredField(this.form.SieveId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.StoneSizeId);
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.MetalId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.PureWeight)
                    q.hideField(this.form.Purity);
                    this.form.CalcOnId.value = "5";
                    this.form.CalcUnitId.value = "8"

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 105;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "124";

                    if (this.form.SubCategoryId.value == "348") {
                        q.hideField(this.form.StoneCutId);
                        q.hideField(this.form.StonePolishId);
                        q.hideField(this.form.StoneSymmetryId);
                        q.hideField(this.form.StoneFluorescenceId);
                        q.hideField(this.form.StoneCuletId);
                        q.hideField(this.form.StoneGirdleId);
                        q.hideField(this.form.StoneTable);
                        q.hideField(this.form.StoneDepth);
                        q.hideField(this.form.CertificateNo);
                    }
                    // **** Solitaire **** //
                    if (this.form.SubCategoryId.value == "349") {
                        q.showAndSetRequiredField(this.form.StoneCutId);
                        q.showAndSetRequiredField(this.form.StonePolishId);
                        q.showAndSetRequiredField(this.form.StoneSymmetryId);
                        q.showAndSetRequiredField(this.form.StoneFluorescenceId);
                        q.showAndSetRequiredField(this.form.StoneCuletId);
                        q.showAndSetRequiredField(this.form.StoneGirdleId);
                        q.showAndSetRequiredField(this.form.StoneTable);
                        q.showAndSetRequiredField(this.form.StoneDepth);
                        q.showAndSetRequiredField(this.form.CertificateNo);
                        q.showAndSetRequiredField(this.form.Pieces);
                        q.showAndSetRequiredField(this.form.Weight);
                        q.showAndSetRequiredField(this.form.Lab);
                    }
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                }
            }
            else {
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.BrandId) : q.showAndSetRequiredField(this.form.BrandId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CollectionId) : q.showAndSetRequiredField(this.form.CollectionId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SuperTypeId) : q.showAndSetRequiredField(this.form.SuperTypeId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductSizeId) : q.showAndSetRequiredField(this.form.ProductSizeId);
                //this.entity.ProductId > 0 ? this.form.HasBom.value == true ? q.showAndDisableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);

                this.form.HasBom.value == true ? q.showFieldAndCategory(this.form.BOMDetails) : q.showFieldAndCategory(this.form.BOMDetails, false);
                this.form.HasBom.value == true ? q.hideField(this.form.Purity) : parseInt(this.form.KaratId.value) > 0 ? q.showAndSetRequiredField(this.form.Purity) : q.showAndDisableField(this.form.Purity);
                this.form.HasBom.value == true ? q.hideField(this.form.PureWeight) : q.showAndDisableField(this.form.PureWeight);
                //this.form.HasBom.value == true ? q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.form.HasBom.value == true ? q.showAndDisableField(this.form.Weight) : q.showAndEnableField(this.form.Weight);
                //this.form.HasBom.value == true ? q.hideEditorTab(this.form.BOMDetails, false) : q.hideEditorTab(this.form.BOMDetails);
                this.form.HasBom.value == true ? this.form.CalcOnId.value = "3" : this.form.CalcOnId.value = "4";
                this.form.HasBom.value == true ? this.form.CalcUnitId.value = "6" : this.form.CalcUnitId.value = "7";
                this.form.HasBom.value == true ? q.hideField(this.form.MetalId) : this.entity.ProductId > 0 ? q.showAndDisableField(this.form.MetalId) : q.showAndSetRequiredField(this.form.MetalId);
                this.form.HasBom.value == true ? q.hideField(this.form.KaratId) : parseInt(this.form.MetalId.value) > 0 ? q.showAndSetRequiredField(this.form.KaratId) : q.showAndDisableField(this.form.KaratId);
                this.form.HasBom.value == false ? parseInt(this.form.KaratId.value) > 0 ? q.showAndSetRequiredField(this.form.UnitRate) : q.showAndDisableField(this.form.UnitRate) : q.showAndDisableField(this.form.UnitRate);


                if (!this.form.HasBom.value) {
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                    q.HideCategoryLable(this.element)
                }
                q.showAndDisableField(this.form.Line_No);
                q.hideEditorTab(this.form.BOMDetails, false);
                q.hideEditorTab(this.form.ImageName, false);
                q.showAndDisableField(this.form.UnitLabour);
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces);
                q.showAndDisableField(this.form.WstPer);
                q.showAndDisableField(this.form.WstWt);
                q.hideField(this.form.MetalColorId);
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.StoneCutId);
                q.hideField(this.form.StonePolishId);
                q.hideField(this.form.StoneSymmetryId);
                q.hideField(this.form.StoneFluorescenceId);
                q.hideField(this.form.StoneCuletId);
                q.hideField(this.form.StoneGirdleId);
                q.hideField(this.form.StoneTable);
                q.hideField(this.form.StoneDepth);
                q.showAndEnableField(this.form.CertificateNo);
                q.showAndEnableField(this.form.Lab);
            }

            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductCode) : q.showAndSetRequiredField(this.form.ProductCode);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductName) : q.showAndSetRequiredField(this.form.ProductName);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductTypeId) : q.showAndSetRequiredField(this.form.ProductTypeId);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CalcOnId) : q.showAndSetRequiredField(this.form.CalcOnId);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CalcUnitId) : q.showAndSetRequiredField(this.form.CalcUnitId);

        }

        // #endregion
         


        protected validateBeforeSave() {
            //this.form.AttributeId.value = "0";
            var t = this.RateListId;
            this.entity.RefTransId == null? this.entity.RefTransId = 0 : this.entity.RefTransId = this.entity.RefTransId
            this.entity.RefTransItemId == null? this.entity.RefTransItemId = 0 : this.entity.RefTransItemId = this.entity.RefTransItemId 
            this.entity.RefVoucherId == null? this.entity.RefVoucherId = 0 : this.entity.RefVoucherId = this.entity.RefVoucherId
            this.entity.Studded == null? this.entity.Studded = 0 : this.entity.Studded = this.entity.Studded
            this.entity.MetalAmount == null? this.entity.MetalAmount = 0 : this.entity.MetalAmount = this.entity.MetalAmount
            this.entity.DiamondAmount == null? this.entity.DiamondAmount = 0 : this.entity.DiamondAmount = this.entity.DiamondAmount
            this.entity.StoneAmount == null? this.entity.StoneAmount = 0 : this.entity.StoneAmount = this.entity.StoneAmount

            if (this.form.ItemTypeId.value == 101) {
                if (this.form.HasBom.value) {
                    let items = this.form.BOMDetails.getItems();
                    let count = 0;
                    if (items.length > 0) {

                        items.forEach(function (x) {
                            if (x.ItemTypeId == 104)
                                count++
                        });

                        if (count == 0) {
                            q.Warning("Can not Save!", "Metal details not defined", false);
                            return false;
                        }
                        else
                            return true;
                    }  
                    else {
                        q.Warning("Can not Save!", "Components or BOM is not defined", false);
                        return false;

                    }
                }

            }
            else {
                this.entity.Studded = 1;
            }

            if (this.form.Weight.value == 0) {
                q.Warning("Can not Save!", "Weight is undefined or 0", false);
                return false;
            }
            else {
                return true;
            }

        }
        // #endregion
         
    }
}